import React from 'react';
import { fireEvent, render, screen } from '@testing-library/react';
import Checkbox from './Checkbox';

jest.mock('components/styleguide/icon/Icon', () => {
  return {
    __esModule: true,
    default: ({ name, ...props }: any) => <span data-icon={name} {...props} />,
  };
});

describe('Checkbox', () => {
  it('renders a checkbox input', () => {
    render(<Checkbox id="test" label="Accept terms" />);
    expect(screen.getByRole('checkbox')).toBeInTheDocument();
  });

  it('renders label associated with checkbox via htmlFor', () => {
    render(<Checkbox id="terms" label="Accept terms" />);
    expect(screen.getByLabelText('Accept terms')).toBeInTheDocument();
  });

  it('toggles checked state in uncontrolled mode', () => {
    render(<Checkbox id="test" label="Accept" />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).not.toBeChecked();
    fireEvent.click(checkbox);
    expect(checkbox).toBeChecked();
  });

  it('calls onChange with name and value in controlled mode', () => {
    const handleChange = jest.fn();
    render(
      <Checkbox id="test" label="Accept" name="terms" checked={false} onChange={handleChange} />
    );
    fireEvent.click(screen.getByRole('checkbox'));
    expect(handleChange).toHaveBeenCalledWith(
      expect.any(Object),
      'terms',
      true
    );
  });

  it('renders disabled state', () => {
    render(<Checkbox id="test" label="Accept" disabled />);
    expect(screen.getByRole('checkbox')).toBeDisabled();
  });

  it('renders error message with alert role', () => {
    render(<Checkbox id="test" label="Accept terms" error="Please accept Terms and Privacy" />);
    expect(screen.getByRole('alert')).toHaveTextContent('Please accept Terms and Privacy');
  });

  it('associates error message with checkbox via aria-describedby', () => {
    render(<Checkbox id="terms" label="Accept" error="Required" />);
    const checkbox = screen.getByRole('checkbox');
    expect(checkbox).toHaveAttribute('aria-describedby', 'terms-error');
    expect(document.getElementById('terms-error')).toHaveTextContent('Required');
  });

  it('sets aria-invalid when error is present', () => {
    render(<Checkbox id="test" label="Accept" error="Required" />);
    expect(screen.getByRole('checkbox')).toHaveAttribute('aria-invalid', 'true');
  });

  it('does not set aria-invalid when no error', () => {
    render(<Checkbox id="test" label="Accept" />);
    expect(screen.getByRole('checkbox')).toHaveAttribute('aria-invalid', 'false');
  });

  it('renders children content', () => {
    render(
      <Checkbox id="test" label="Accept">
        <span>Extra info</span>
      </Checkbox>
    );
    expect(screen.getByText('Extra info')).toBeInTheDocument();
  });

  it('renders with default checked state', () => {
    render(<Checkbox id="test" label="Accept" checked />);
    expect(screen.getByRole('checkbox')).toBeChecked();
  });

  it('renders required attribute', () => {
    render(<Checkbox id="test" label="Accept" required />);
    expect(screen.getByRole('checkbox')).toBeRequired();
  });

  it('renders error icon when error is present', () => {
    const { container } = render(<Checkbox id="test" label="Accept" error="Error" />);
    expect(container.querySelector('[data-icon="triangleAlert"]')).toBeInTheDocument();
  });
});
